<template>
    <div class="modify-approve--add-sync">
        <div class="content">
        <vxe-table
            class='atb-table header-table edit-table'
            border='full'
            height='100%'
            auto-resize
            resizable
            :data="modifyApproveData"
            ref="modifyApproveTable"
            :row-class-name="setRowClass"
            :merge-cells="mergeCells"
        >
            <vxe-table-column type="workItemNo" width="50" title="序号" align="center">
              <template #default="scope">
                  <template v-if="scope.rowIndex === 0">
                    <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                        <span>修改前</span>
                    </div>
                  </template>
                  <template v-else-if="scope.rowIndex === beforeModifyLength + 1">
                    <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                        <span>修改后</span>
                    </div>
                  </template>
                   <template v-else>
                      <span v-if="scope.rowIndex <= beforeModifyLength">{{scope.rowIndex}}</span>
                      <span v-else-if="scope.rowIndex > beforeModifyLength + 1 && scope.rowIndex <= afterModifyLength + beforeModifyLength + 2">{{scope.rowIndex - beforeModifyLength - 1}}</span>
                  </template>
              </template>
            </vxe-table-column>
            <vxe-table-column field="workClassify" title="工作分类" width="100">
              <template #default="{ row, rowIndex }">
               <div :class="rowIndex>beforeModifyLength + 1&&(beforeModify[0]&&beforeModify[0]['workClassify']!=row.workClassify)? contrast: ''">
                 <span>{{ row.id ? workClassifyList.find(t => t.itemValue == row.workClassify).itemDesc : ''}}</span>
               </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="workItemCategory" title="类别" width="100">
              <template #default="{ row, rowIndex }">
               <div :class="rowIndex>beforeModifyLength + 1&&(beforeModify[0]&&beforeModify[0]['workItemCategory']!==row.workItemCategory)? contrast: ''">{{row.workItemCategory}}
               </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="workItemContent" width="100" title="工作项目">
              <template #default="{ row, rowIndex }">
               <div :class="rowIndex>beforeModifyLength + 1&&(beforeModify[0]&&beforeModify[0]['workItemContent']!==row.workItemContent)? contrast: ''">{{row.workItemContent}}
               </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="wholeTarget" width="120" :title="extend==='Year'? '全年目标': '总目标'">
              <template #default="{ row, rowIndex }">
               <div :class="rowIndex>beforeModifyLength + 1&&(beforeModify[0]&&beforeModify[0]['wholeTarget']!==row.wholeTarget)? contrast: ''">{{row.wholeTarget}}
               </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="finishDate" width="125" :title="extend==='Year'? '最终完成日期': '总目标完成时间'">
              <template #default="{ row, rowIndex }">
                <div :class="rowIndex>beforeModifyLength + 1&&(beforeModify[0]&&beforeModify[0]['finishDate']!==row.finishDate)? contrast: ''">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="currentTarget" width="120" :title="extend==='Year'? '上半年目标': '当前目标'">
              <template #default="{ row, rowIndex }">
               <div :class="(rowIndex>beforeModifyLength + 1)&&(beforeModify[0]&&beforeModify[0]['currentTarget']!==row.currentTarget)? contrast: ''">{{row.currentTarget}}
               </div>
              </template>
            </vxe-table-column>
             <vxe-table-column field="currentFinishDate" width="140" title="当前目标完成时间" v-if="extend !== 'Year'">
              <template #default="{ row, rowIndex }">
                <div :class="rowIndex>beforeModifyLength + 1&&(beforeModify[0]&&beforeModify[0]['currentFinishDate']!==row.currentFinishDate)? contrast: ''">{{ formatDate(row.currentFinishDate, 'yyyy-MM-dd') }}
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="weight" title="权重" width="60">
              <template #default="{ row, rowIndex }">
               <div :class="rowIndex>beforeModifyLength + 1&&(beforeModify[0]&&beforeModify[0]['weight']!==row.weight)? contrast: ''">{{row.weight}}
               </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="completeStatus" title="完成情况" width="80" v-if="extend !== 'Year'">
              <template #default="{ row, rowIndex }">
               <div :class="rowIndex>beforeModifyLength + 1&&(beforeModify[0]&&beforeModify[0]['completeStatus']!=row.completeStatus)? contrast: ''">
                 <!-- <span v-if="row.completeStatus == 0">计划</span> -->
                 <span v-if="row.completeStatus == 10">未完成</span>
                 <span v-if="row.completeStatus == 20 && extend == 'Month'">月目标已完成</span>
                 <span v-if="row.completeStatus == 20 && extend == 'Week'">周目标已完成</span>
                 <span v-if="row.completeStatus == 25">总目标完成</span>
                 <span v-if="row.completeStatus == 30">延迟</span>
                 <span v-if="row.completeStatus == 40">转移</span>
                 <span v-if="row.completeStatus == 50">关闭</span>
               </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="modifyReason" title="修订原因" width="120">
              <template #default="{ row, rowIndex }">
               <div :class="rowIndex>beforeModifyLength + 1&&(beforeModify[0]&&beforeModify[0]['modifyReason']!==row.modifyReason)? contrast: ''">{{row.modifyReason}}
               </div>
              </template>
            </vxe-table-column>
            </vxe-table>
        </div>
        <div class="form-wrap" v-if="hideApprove">
          <el-form :model="editForm" :rules="rules" ref="form" label-width='92px' class="atb-input" label-position="right">  
            <el-form-item label="审批意见" prop="approveReason" label-width="80px">
              <el-input :readonly="!role" type="textarea" maxlength="500" v-model="editForm.approveReason"></el-input>
              <fast-approve v-if="role" @approveText="approveText"></fast-approve>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-wrap">
            <el-button v-if="role" type="passed" class="btn" @click="passed">通过</el-button>
            <el-button v-if="role" type="rejected" class="btn" @click="rejected">驳回</el-button>
            <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
        </div>
    </div>
</template>
<script>
import editMixin from '@/mixins/edit.mixin'
import XEUtils from 'xe-utils'
export default {
  mixins: [ editMixin ],
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    },
    msgObjectId:{
      type: String,
      default:''
    },
    role:{
      type:Number,
      default:0
    },
    extend:{
      type:String,
      default:''
    },
    hideApprove: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      id: 'id',
      editForm: {
        approveReason:''
      },
      mergeCells: [
        {row: 0, col: 0, rowspan: 1, colspan: 11},
        {row: 1, col: 0, rowspan: 1, colspan: 11},
      ],
      beforeModify: [],
      afterModify: [],
      contrast: "modify-row",
      workClassifyList: []
    }
  },
  computed: {
    beforeModifyLength() {
      return this.beforeModify.length;
    },
    afterModifyLength() {
      return this.afterModify.length;
    },
    modifyApproveData() {
      return [{}, ...this.beforeModify, {}, ...this.afterModify];
    },
    tableColumnLength() {
      return this.tableColumn.filter((val) => val.visible !== false).length;
    },
  },
  created() {
    if(this.extend === "Year"){
      this.getYearWorkClassify().then(() => {
        this.getList();
      });
    }else if (this.extend === "Month") {
      this.getMonthWorkClassify().then(() => {
        this.getList();
      });
    }else{
      this.getWeekWorkClassify().then(() => {
        this.getList();
      });
    }
    
  },
  mounted(){
    this.$nextTick(() => {
     this.tableColumn = this.$refs.modifyApproveTable.getColumns();
   })
  },
  methods:{
    approveText(e) {
      this.editForm.approveReason = e;
    },
    querySearchWeight(queryString, cb) {
        let weightList = this.weightList;
        // 调用 callback 返回建议列表的数据
        cb(weightList);
    },
    getList() {
      this.$ajax.get(this.$api.WorkitemModify.list,{id: this.msgObjectId}).then((res) => {
        res.data&&this.filterSyncTableData(res.data);
        if (!res.data) {
          this.monthTableData = [{}, {}];
        }
        
      });
    },
    filterSyncTableData(data) {
      if(data instanceof Object){
        this.editForm.approveReason=data.approveReason;
        this.beforeModify = [JSON.parse(data.modifyPre)];
        this.afterModify = [JSON.parse(data.modifyAfter)];
      }
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    setRowClass({rowIndex}) {
        if (rowIndex == 0 || rowIndex == this.beforeModifyLength + 1) {
          return 'main-row';
        }
    },
    passed(){
      const params={};
      params.id=this.msgObjectId;
      params.approveReason=this.editForm.approveReason;
      params.approveState= 1;
      this.$ajax.put(this.$api.WorkitemModify.update, params).then(res=>{
          if(res.code===0){
              this.$refs.form.resetFields();
              this.$message.success('审批成功');
              this.$emit('submitSuccess');
              this.editForm={};
              this.$parent.$parent.hide();
          }
        });
    },
    rejected(){
      const params={};
      params.id=this.msgObjectId;
      params.approveReason=this.editForm.approveReason;
      params.approveState= 0;
      if(typeof(params.approveReason)==="undefined" || params.approveReason===null || params.approveReason.split(" ").join("").length === 0 || params.approveReason.replace(/\s+/g,"").length===0){
        return  this.$message.error("必须填写驳回原因");
      }
      this.$ajax.put(this.$api.WorkitemModify.update, params).then(res=>{
        if(res.code===0){
            this.$refs.form.resetFields();
            this.$message.success('审批成功');
            this.$emit('submitSuccess');
            this.editForm={};
            this.$parent.$parent.hide();
        }
      });
    },
    async getYearWorkClassify() {
      await this.$ajax.get(this.$api.common.getDict, { ItemType: 'YearPlanWorkItemClassify' }).then((res) => {
        if (res.code === 0) {
          this.workClassifyList = (res.data && res.data.rows) || [];
        }
      });
    },
    async getMonthWorkClassify() {
      await this.$ajax.get(this.$api.common.getDict, { ItemType: 'MonthWorkItemClassify' }).then((res) => {
        if (res.code === 0) {
          this.workClassifyList = (res.data && res.data.rows) || [];
        }
      });
    },
    async getWeekWorkClassify() {
      await this.$ajax.get(this.$api.common.getDict, { ItemType: 'WeekWorkItemClassify' }).then((res) => {
        if (res.code === 0) {
          this.workClassifyList = (res.data && res.data.rows) || [];
        }
      });
    },
  },
 watch: {
      modifyApproveData: {
        handler() {
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength},
            {row: this.afterModifyLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength}
          ];
        }
      }
    }
}
</script>
<style scoped lang='scss'>
  .modify-approve--add-sync {
    .content{
        height: 350px;
    }
    .el-button.el-button--passed {
        color: #ffffff;
        background-color: #22b6a1;
        border-color: #22b6a1;
    }
    .el-button.el-button--rejected {
        background-color: #0dcc82;
        border-color: #0dcc82;
        color: #ffffff;
    }
    .el-button.el-button--clear {
        background-color: #F5BF2B;
        border-color: #F5BF2B;
        color: #ffffff;
    }
    .el-button {
        width: 110px;
        border-radius: 10px;
    }
    .btn-wrap{
         text-align: right;
         margin-top: 10px;
    }
    .form-wrap{
        margin: 10px 0px;
        .el-autocomplete{
            width: 100%;
        }
        .customerSelect{
            width: 100%;
        }
    }
    ::v-deep .header-table {
      overflow: auto;
      flex-grow: 1;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .main-row {
        .vxe-body--column {
          padding: 0;
        }
        .vxe-cell {
          padding: 0;
        }
      }
      .modify-row{
        font-weight: bolder;
        color: #2c3130;
      }
    }
    .kpi-add {
      height: 48px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      margin-top: -1px;
      padding: 0 15px;
      span {
        cursor: pointer;
      }
    }
    .atb-input {
      .el-form-item{
        margin-right: 0px;
      }
    }
  }
</style>